// choices/roomChoices.js
const roomChoicesRo = [
  { label: "Living 🛋️", value: "living-room" },
  { label: "Bucătărie 🎛️", value: "kitchen" },
  { label: "Sufragerie 🍴", value: "dining-room" },
  { label: "Dormitor 🛏️", value: "bedroom" },
  { label: "Baie 🛁", value: "bathroom" },
  { label: "Camera copiilor 👶", value: "kids-room" },
  { label: "Camera adolescentului 👦", value: "teen-room" },
];

export default roomChoicesRo;
